<template>
  <v-container fluid>
    <div><v-switch v-model="onlyShowReposts" label="Only Reposts" hint="Only show reposts" @change="loadHistory"></v-switch></div>
    <v-data-table
        :headers="tableHeaders"
        :items="checkedPosts"
        class="elevation-1"
        :loading="loading"
        :options.sync="options"
        :server-items-length="maxCount"
        :footer-props=footerProps
        disable-sort
        @click:row="rowOnClick"
    >
      <template v-slot:item.created="{ item }">
        {{ item.created | formatTimestamp}}
      </template>
      <template v-slot:item.title="{ item }">
        {{ item.title | truncate(65)}}
      </template>
      <template v-slot:item.matches="{ item }">
        <v-chip :color="getMatchColor(item.matches)" dark>{{ item.matches }}</v-chip>
      </template>
      <template v-slot:item.postTypeId="{ item }">
        {{postTypeFromId(item.postTypeId)}}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon
            small
            class="mr-2"
            @click="openSearch(item)"
            :disabled="item.postTypeId !== 2"
        >
          mdi-magnify
        </v-icon>

      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {searchHistoryMixin} from "@/util/mixins/searchHistoryMixin";
const HistoryRepo = RepositoryFactory.get('history')
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import {postTypeFromId} from "@/util/helpers";
export default {
name: "PostHistory",
  mixins: [searchHistoryMixin],
  props: {
    subredditName: String,
  },
  data: () => ({
    footerProps: {"items-per-page-options": [10,20,50,100,500]},
    checkedPosts: [],
    onlyShowReposts: false,
    reposts: [],
    loading: true,
    maxCount: 1000,
    options: {},
    limit: 20,
    tableHeaders: [
      {text: 'Created', value: 'created'},
      {text: 'ID', value: 'id'},
      {text: 'Type', value: 'postTypeId'},
      {text: 'Author', value: 'author'},
      {text: 'Title', value: 'title'},
      {text: 'Matches', value: 'matches'},
      {text: 'Search Time', value: 'searchTime'},
      { text: 'Search', value: 'actions', sortable: false },
    ]
  }),
  mounted() {
    this.loadHistory();
  },
  methods: {
    postTypeFromId,
    rowOnClick(row) {
      window.open(`https://redd.it/${row.id}`)
    },
    openSearch(search) {
    let queryParams = {
      postId: search.id,
      memeFilter: search.memeFilter ? 'true' : 'false',
      sameSub: search.sameSub ? 'true' : 'false',
      filterDeadMatches: search.filterDeadMatches ? 'true' : 'false',
      filterOnlyOlder: search.filterOnlyOlder ? 'true' : 'false',
      filterSameAuthor: search.filterSameAuthor ? 'true': 'false',
      filterCrossposts: search.filterCrossposts ? 'true': 'false',
      targetImageMatch: search.targetImageMatch,
      targetImageMemeMatch: search.targetImageMemeMatch
    }
      let routeData = this.$router.resolve({name: 'Search', query: queryParams});
      window.open(routeData.href, '_blank');
    },
    getMatchColor(count) {
      if (count === 0) {
        return 'green'
      } else {
        return 'red'
      }
    },
    loadHistory() {
      this.loading = true;
      this.getSearchHistory(this.onlyShowReposts)
          .then(res => {
            this.checkedPosts = res.sort((a, b) => b.created - a.created);
            this.loading = false;
          })
    },
    getSearchHistory(repostOnly) {
      // eslint-disable-next-line no-unused-vars
      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      return HistoryRepo.getRecentChecks({
        'params': {
          'subreddit': this.subredditName,
          'limit': itemsPerPage,
          'offset': (itemsPerPage * page) - itemsPerPage,
          'repost_only': repostOnly
        }
      })
          .then(searches => {
            if (searches.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: searches.data})
              return results;
            }
            let results = [];
            searches.data.forEach(searchResult => {
              let searchRecord = {
                id: searchResult.checked_post.post_id,
                author: searchResult.checked_post.author,
                created: searchResult.checked_post.created_at,
                title: searchResult.checked_post.title,
                matches: searchResult.search.matches_found,
                searchTime: searchResult.search.search_time,
                subreddit: this.subredditName,
                memeFilter: searchResult.search.meme_filter,
                sameSub: searchResult.search.same_sub,
                postTypeId: searchResult.checked_post.post_type_id,
                filterDeadMatches: searchResult.search.filter_dead_matches,
                filterOnlyOlder: searchResult.search.only_older_matches,
                targetImageMatch: searchResult.search.target_image_match,
                targetImageMemeMatch: searchResult.search.target_image_meme_match,
                filterSameAuthor: searchResult.search.filter_same_author,
                filterCrossposts: searchResult.search.filter_crossposts

              }
              results.push(searchRecord);
            })
            return results;

          })
    },

  },

  watch: {
    options: {
      handler() {
        this.loadHistory();
      },
      deep: true
    },
    selectedSubreddit: function() {
      this.checkedPosts = [];
      this.loadHistory();
    }
  }
}
</script>

<style scoped>

</style>
